module.exports = __webpack_public_path__ + "static/media/pets_allowed.8f60fc58.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/amenities/pets_allowed.svg
// module id = 573
// module chunks = 0